<template>
  <main className="content-500" id="faq">
    <div class="title color-black">
      <h1>FAQ</h1>
      <h2>Deine Benachrichtigungen</h2>
    </div>
    <section class="pad-16">
      <div class="bgcolor-white br-10 pad-16" style="cursor: pointer;" @click="noTicketInfo = !noTicketInfo">
        <div class="t-center">
          <span style="width: 64px; height: 64px; display: inline-block;" class="bgcolor-blue br-32">
            <svg style="vertical-align: -8px; margin-top: 8px;" width="48px" viewBox="0 0 64 64" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><path d="m62.981 20.549-3.557-3.571c-1.431-1.437-3.636-.265-3.636-.265l-.006-.004a6.318 6.318 0 0 1-6.91-1.367 6.319 6.319 0 0 1-1.337-6.923c.009-.022.009-.036.019-.059.83-2.196-.35-3.637-.698-4.001L43.282.771c-1.561-1.567-3.256-.142-3.671.257L1.035 39.45c-2.143 2.132-.376 3.835-.376 3.835l4.139 4.155s1.021 1.104 3.003.304c.063-.025.111-.036.166-.053 2.356-1.135 5.261-.744 7.21 1.212a6.32 6.32 0 0 1 1.359 6.882h.003s-1.204 2.235.244 3.688l3.625 3.64c.258.254 2.163 1.965 4.541-.401l38.329-38.173c.578-.673 1.48-2.206-.297-3.99zm-39.525 24.65-.329.326c-.369.368-.747.132-.939-.039l-4.249-4.267-1.07 1.067c-.542.541-1.005-.017-1.005-.017l-.142-.143s-.385-.346.201-.928l3.254-3.241s.512-.566 1-.078l.111.111c.365.388.137.738-.02.908L19.164 40l4.085 4.103c.507.508.364.89.207 1.096zm3.617-3.603-.266.265c-.414.413-.956-.063-1.088-.189l-4.487-4.507s-.619-.637-.111-1.141l.189-.188s.538-.501 1.278.243l4.405 4.422c.487.49.242.908.08 1.095zm5.474-5.723a5.86 5.86 0 0 1-1.097 1.52c-.84.837-1.736 1.221-2.688 1.154-.953-.064-1.904-.574-2.854-1.527-.597-.601-1.012-1.233-1.243-1.905-.231-.669-.262-1.326-.092-1.976s.529-1.246 1.079-1.795c.44-.438.992-.772 1.603-1.045.203-.033.577-.036.755.379l.069.162c.304.71-.546.947-.546.947l.001.003c-.035.017-.074.031-.11.047a2.661 2.661 0 0 0-.757.527c-.461.457-.645.987-.553 1.585.092.597.446 1.204 1.062 1.823 1.282 1.286 2.408 1.45 3.374.487.281-.278.553-.686.82-1.146l.02.006s.352-.607.683-.276l.205.207c.347.321.326.631.269.823zm5.841-5.547-.585.583c-.364.362-.936.226-.936.226l-3.362-.792-.146.886 1.388 1.394c.498.499.387.884.23 1.104l-.303.298c-.426.427-.907.054-1.088-.119l-4.517-4.535s-.636-.632-.177-1.087l.282-.281c.177-.148.598-.374 1.151.181l1.968 1.976-.196-1.16-.34-3.06s-.053-.457.294-.803l.458-.457s.555-.56.647.245c0 0 .002 0 .002.003l.438 3.76 4.53 1.037c.242.066.627.236.262.601zm4.14-3.996-2.213 2.205c-.576.574-1.113.137-1.266-.011l-4.468-4.484s-.555-.744.029-1.327l2.164-2.154s.456-.51.833-.131l.173.172s.531.427-.007.962l-1.179 1.173c-.451.451-.003.875-.003.875l.348.346s.471.493 1.007-.042l.948-.945s.471-.485.833-.123l.141.142c.396.432.219.767.084.925l-.912.909c-.571.568-.249.989-.147 1.095l.624.627c.188.147.495.276.822-.05l1.164-1.16s.478-.516.791-.203l.198.198c.421.435.195.819.036 1.001zm3.176-3.289-.192.189c-.381.379-.85-.017-1.002-.165l-3.625-3.639c-.47-.471-.875-.18-1.016-.049l-.657.656c-.458.457-.886-.039-.886-.039l-.174-.176s-.382-.38.076-.837l3.369-3.354c.203-.183.612-.456.963-.104l.109.111c.389.41.165.772.024.931l-.678.674c-.091.095-.389.482.156 1.031l3.564 3.579c.197.222.478.693-.031 1.192z" fill="#ffffff" class="fill-241f20"></path></svg>
          </span>
          <h6 style="font-size: 1.2em;" class="color-blue pad-8">Ich habe kein Ticket erhalten</h6>
        </div>
      </div>
      <div v-if="noTicketInfo" class="bgcolor-white br-10 pad-24 color-black">
        <h3 style="font-size: 1.4em;">Ich habe kein Ticket erhalten. <br>Was kann ich tun?</h3>
        <p class="color-grey">Solltest du dein Ticket nach der Bestellung nicht erhalten haben, kann dies verschiedene Gründe haben.</p>
        <br>
        <h4 style="font-size: 1.1em;">Check deinen Spam Ordner</h4>
        <p class="color-grey">Ist unsere Mail fälschlicher Weise in deinen Spam Ordner gerutscht?</p>
        <br>
        <h4 style="font-size: 1.1em;">Deine Zahlung wurde abgelehnt oder konnte nicht abgebucht werden</h4>
        <p class="color-grey">Prüfe, ob der Betrag von deinem Konto wirklich bezahlt wurde.</p>
        <br>
        <h4 style="font-size: 1.1em;">Du hast die falsche E-Mail Adresse angegeben</h4>
        <p class="color-grey">Das kann durchaus passieren! Leider kann dir dabei nur unser Support helfen.</p>
        <br>
        <h3 style="font-size: 1.4em;">Hat nichts geholfen? <br>Dann hilft dir unser Support.</h3>
        <br>
        <router-link to="/lostticket" style="max-width: 100%;" class="button bgcolor-blue t-center color-white">
          Ticket erneut zusenden / runterladen
        </router-link>
        <br>
        <p class="color-grey" style="margin-top: 16px;">
          Du erreichst uns telefonisch unter<br>
          <a href="tel:+4951112282957" class="color-blue">+49 511 12282957</a><br><br>
          oder per Mail unter <br>
          <a href="mailto:info@partyticket.eu" class="color-blue">info@partyticket.eu</a>
        </p>
        <br><br>

        <h4 style="font-size: 1.1em;">Bitte gib uns folgende Informationen durch:</h4>
        <br>
        <p class="color-grey">
        - Link zur Eventseite der gekauften Tickets<br>
        - Name & Datum der Veranstaltung<br>
        - Angegebene E-Mail Adresse<br>
        - Angegebener Name<br>
        </p>
        <br>
        <button @click="noTicketInfo = false" class="button fluid bgcolor-blue color-white">Info schließen</button>
      </div>
    </section>
    <section class="pad-16">
      <div v-for="(item, index) in items" :key="index" class="accordion-item">
        <div class="accordion-header color-blue" :class="{ active: isActive(index) }" @click="toggleAccordion(index)">
          {{ item.title }}
        </div>
        <div class="accordion-content" :class="{ active: isActive(index) }">
          {{ item.content }}
        </div>
      </div>
      <p class="pad-16 t-center color-black" style="font-size: 1.2em;">
        Du hast weitere Fragen?<br>
        <span class="color-blue">info@partyticket.eu</span> hilft dir weiter!
      </p>
    </section>
  </main>
</template>

<script>
import {authStore} from "@/store/authStore";
import {configStore} from "@/store/configStore";
import {userStore} from "@/store/userStore";


export default {
  name: "FAQ",
  title: "FAQ",
  components: {
  },
  setup() {
    const auth = authStore()
    const config = configStore()
    const user = userStore()

    return {auth, config, user}
  },
  mounted() {
    this.config.loading = false
  },
  data() {
    return {
      noTicketInfo: false,
      items: [
        { title: "WIE LANGE DAUERT ES BIS ICH DAS TICKER ERHALTE?", content: "Das Partyticket System schickt sofort deine Tickets raus. Schau bitte in deinem E-Mail Postfach auch im Spam-Ordner nach. Sollte 15 Minuten nach Bestellung noch kein Ticket bei dir eingegangen sein, so schreib uns bitte eine E-Mail an: info@partyticket.eu unter Angabe deiner Bestellnr., deiner angegebenen E-Mail und deinem Namen."},
        { title: "AUF DEM TICKET STEHT MEIN NAME, ES IST ABER NICHT FÜR MICH?", content: "Das ist kein Problem! Es zählt nur der gültige QR Code."},
        { title: "MUSS MAN ONLINE KARTEN ZUSÄTZLICH AKTIVIEREN?", content: "Nein, die Online Karten müssen nicht aktiviert werden." },
        { title: "MUSS MAN ONLINE KARTEN AUSDRUCKEN ODER REICHEN SIE AUF DEM HANDY?", content: "Die Online Karten kannst du ganz bequem per Smartphone am Einlass vorzeigen."},
        { title: "SIND ONLINE KARTEN ÜBERTRAGBAR?", content: "Online Karten sind in den meisten Fällen unpersonalisiert, das heißt, dass diese Übertragbar sind." },

      ],
      activeIndex: null
    };
  },
  methods: {
    isActive(index) {
      return this.activeIndex === index;
    },
    toggleAccordion(index) {
      if (this.activeIndex === index) {
        this.activeIndex = null;
      } else {
        this.activeIndex = index;
      }
    }
  }
}
</script>

<style>
#faq .title h1{
  margin-top: 16px;
  font-size: 2em;
  font-weight: 800;
  text-transform: uppercase;
  text-align: center;
}
#faq .title h2{
  font-size: 1.1em;
  font-weight: 200;
  color: rgba(0,0,0,0.8);
  text-align: center;
  margin-bottom: 32px;
}
.accordion-item {
  margin-bottom: 8px;
}

.accordion-header {
  cursor: pointer;
  padding: 16px 12px;
  background-color: #ffffff;
  font-size: 0.8em;
  font-weight: bold;
}

.accordion-header.active {
  background-color: #2014ff;
  color: #ffffff!important;
}

.accordion-content {
  padding: 16px;
  background-color: #fff;
  color: #00000080;
  display: none;
  font-size: 0.9em;
}

.accordion-content.active {
  display: block;
}

</style>